// onboarding_wizard/onboarding.ts
import learning from 'assets/images/register/Step3/learning.svg';
import money from 'assets/images/register/Step3/money.svg';
import job from 'assets/images/register/Step3/job.svg';
import analysis from 'assets/images/register/Step3/analysis.svg';
import chat from 'assets/images/register/Step3/chat.svg';
import crm from 'assets/images/register/Step3/crm.svg';
import adviser from 'assets/images/register/Step3/adviser.svg';
import agreement from 'assets/images/register/Step3/agreement.svg';
import planning from 'assets/images/register/Step3/planning.svg';
import documentation from 'assets/images/register/Step3/documentation.svg';

export interface RolesOption {
  value: string;
  label: string;
}

export const RolesOptions: RolesOption[] = [
  { value: '', label: 'Selecionar' },
  { value: '74', label: 'Proprietário(a) / Sócio(a)' },
  { value: '25', label: 'Presidente / CEO' },
  { value: '36', label: 'Administrador(a)' },
  { value: '3', label: 'Diretor(a)' },
  { value: '44', label: 'Engenheiro(a)' },
  { value: '4', label: 'Gerente' },
  { value: '81', label: 'Analista de licitação' },
  { value: '65', label: 'Assistente administrativo' },
  { value: '38', label: 'Advogado' },
  { value: '43', label: 'Contador' },
  { value: '64', label: 'Consultor(a)' },
  { value: '66', label: 'Representante' },
  { value: '172', label: 'Servidor público' },
];

export const STEP1_OPTIONS = {
  cargo_id: RolesOptions,

  teamSize: [
    { value: '', label: 'Selecionar' },
    { value: '1', label: '1' },
    { value: '2 a 5', label: '2 a 5' },
    { value: '6 a 10', label: '6 a 10' },
    { value: 'Mais de 10', label: 'Mais de 10' },
  ],

  biddingsPerMonth: [
    { value: '', label: 'Selecionar' },
    { value: '1 a 5', label: '1 a 5' },
    { value: '6 a 15', label: '6 a 15' },
    { value: '16 a 30', label: '16 a 30' },
    { value: 'Mais de 30', label: 'Mais de 30' },
  ],

  annualRevenue: [
    { value: '', label: 'Selecionar' },
    { value: 'Até R$ 500 mil', label: 'Até R$ 500 mil' },
    { value: 'R$ 500 mil a R$ 2 milhões', label: 'R$ 500 mil a R$ 2 milhões' },
    { value: 'R$ 2 a R$ 10 milhões', label: 'R$ 2 a R$ 10 milhões' },
    { value: 'Acima de R$ 10 milhões', label: 'Acima de R$ 10 milhões' },
  ],
} as const;

export const STEP3_GOALS = [
  { id: 'aprender', label: 'Aprender a vender para o governo', icon: learning },
  { id: 'acelerar-analise-editais', label: 'Acelerar a análise de editais', icon: money },
  { id: 'encontrar-licitacao', label: 'Encontrar oportunidades no meu setor', icon: job },
  { id: 'monitorar-concorrente', label: 'Monitorar meus concorrentes', icon: analysis },
  { id: 'monitoramento-chat', label: 'Monitorar o chat do pregão', icon: chat },
  { id: 'representante', label: 'Atuar como representante para terceiros', icon: crm },
  { id: 'controle-documentos', label: 'Controlar o vencimento de documentos', icon: documentation },
  { id: 'duvidas-juridicas', label: 'Tirar dúvidas e ter apoio jurídico', icon: adviser },
  { id: 'recurso-peticoes', label: 'Obter modelos de recursos e petições', icon: agreement },
  { id: 'gerenciar-processo', label: 'Gerenciar todo o processo licitatório', icon: planning },
] as const;
